import * as React from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import MuiInput from "@mui/material/Input";
import { useState } from "react";
import Answered from "./Answered";

const Input = styled(MuiInput)`
  width: 42px;
`;

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const PrettoSlider = styled(Slider)({
  color: "#966c51",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#966c51",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

function SliderQuestion(props) {
  const {
    question,
    number,
    choices,
    answer,
    image,
    alt,
    explanation,
    link,
    setNumAnswered,
    setNumCorrect,
    imgPath,
  } = props;
  const [answered, setAnswered] = useState(false);
  const [correct, setCorrect] = useState(false);
  const [close, setClose] = useState(false);
  const [selectedValue, setSelectedValue] = useState(50);
  const [color, setColor] = useState("#966c51");

  const handleSliderChange = (event, newValue) => {
    setSelectedValue(newValue);
  };

  const handleInputChange = (event) => {
    setSelectedValue(
      event.target.value === "" ? 0 : Number(event.target.value)
    );
  };

  const handleClick = () => {
    const upperBound = Math.min(answer + 5, 100);
    const lowerBound = Math.max(answer - 5, 0);
    const close = lowerBound <= selectedValue && selectedValue <= upperBound;
    setClose(answer === selectedValue ? false : close); // correct --> close = false

    setAnswered(true);
    setCorrect(answer === selectedValue || close);

    setNumAnswered((c) => c + 1);
    if (answer === selectedValue || close) {
      setNumCorrect((c) => c + 1);
    }

    if (correct) {
      setColor("#8ac277");
    } else {
      // setSelectedValue(answer);
      setColor("#e55550");
    }
  };

  const handleBlur = () => {
    if (selectedValue < 0) {
      setSelectedValue(0);
    } else if (selectedValue > 100) {
      setSelectedValue(100);
    }
  };

  return (
    <div>
      <div className="Question SliderQ">
        <h4 className="num">{number}.</h4>
        {image != null && image.length > 0 && (
          <img src={imgPath + image} alt={alt} />
        )}
        <h4>{question}</h4>

        <div className="SliderBlock">
          <PrettoSlider
            valueLabelDisplay="auto"
            aria-label="input slider"
            defaultValue={50}
            onChange={handleSliderChange}
            value={selectedValue}
            className="Slider"
            disabled={answered}
          />
          <Input
            value={selectedValue}
            size="small"
            onChange={handleInputChange}
            onBlur={handleBlur}
            className="Input"
            inputProps={{
              step: 10,
              min: 0,
              max: 100,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
            disabled={answered}
          />
        </div>

        {!answered && (
          <button
            className={"Choice AllButton"}
            onClick={handleClick}
            name={"submit button"}
          >
            Submit!
          </button>
        )}

        {answered && (
          <Answered
            correct={correct}
            explanation={explanation}
            close={close}
            link={link}
          />
        )}
      </div>
      <hr />
    </div>
  );
}

export default SliderQuestion;
